

(function () {
  'use strict';

  function reveal(section) {
    if (section.classList.contains('is-revealed')) return;
    section.classList.add('is-revealed');
  }

  function init() {
    var sections = document.querySelectorAll('.cerus-section[data-cerus-reveal], .cerus-section:not([data-cerus-reveal])');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    sections.forEach(function (s) { io.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
